import type { KioskUser } from '@iheartjane/types';
import type { UseQueryOptions } from '@tanstack/react-query';

import { getJwt } from '@jane/shared/auth';
import { createUseQueryHook, janeApi } from '@jane/shared/data-access';

import { kioskAuthenticationQueryKeys } from '../authentication/authentication.util';

const fetchKioskUser = async (): Promise<KioskUser | null> => {
  const url = `/kiosk/users/whoami`;

  try {
    return await janeApi.get<KioskUser>(url, getJwt());
  } catch (err: any) {
    if (err?.response?.status === 401) {
      // /whoami without a login throws an unauthorized error, it does not return a response,
      // we want react query to receive a response that indicates there is no user.
      return null;
    }
    // React Query can handle the other errors
    throw err;
  }
};

export const useKioskUser = createUseQueryHook<void, KioskUser | null>(
  fetchKioskUser,
  kioskAuthenticationQueryKeys.kioskUser,
  undefined
);

export const useKioskUserSegmentIds = (
  queryOptions: UseQueryOptions<KioskUser | null, Error> = {}
): number[] | undefined => {
  const { data: kioskUser } = useKioskUser(undefined, queryOptions);
  return kioskUser?.user_segments || [];
};
